function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { mapGetters } from 'vuex';
export default {
  components: _objectSpread({}, mapGetters(['person'])),
  methods: {
    bmi: function bmi(person, weight) {
      if (person.size === null || person.age === null || weight === null) {
        return null;
      }

      var s = person.size / 100;
      var bmi = weight / (s * s); // console.debug('bmi: ' + bmi)

      return Math.round(bmi);
    },
    status: function status(bmi) {
      if (bmi === null) {
        return null;
      }

      if (bmi < 18.5) {
        return t('health', 'Underweight');
      } else if (bmi >= 18.5 && bmi < 25) {
        return t('health', 'Normal weight');
      } else if (bmi >= 25 && bmi < 30) {
        return t('health', 'Pre-obesity');
      } else if (bmi >= 30 && bmi < 35) {
        return t('health', 'Obesity class I');
      } else if (bmi >= 35 && bmi < 40) {
        return t('health', 'Obesity class II');
      } else {
        return t('health', 'Obesity class III');
      }
    },
    statusClass: function statusClass(bmi) {
      var data = {
        okay: false,
        good: false,
        warning: false,
        alert: false,
        danger: false
      };

      if (bmi < 18.5) {
        data.okay = true;
      } else if (bmi >= 18.5 && bmi < 25) {
        data.good = true;
      } else if (bmi >= 25 && bmi < 30) {
        data.okay = true;
      } else if (bmi >= 30 && bmi < 35) {
        data.warn = true;
      } else if (bmi >= 35 && bmi < 40) {
        data.alert = true;
      } else {
        data.danger = true;
      }

      return data;
    },
    bodyfat: function bodyfat(weight, age, sex) {
      if (!weight || !age || !sex) {
        return null;
      }

      var bmi = this.bmi(this.person, weight);
      var sexNumber = sex === 'female' ? 0 : 1;

      if (age <= 15) {
        return 1.51 * bmi - 0.7 * age - 3.6 * sexNumber + 1.4;
      } else {
        return 1.39 * bmi + 0.16 * age - 10.34 * sexNumber - 9;
      }
    }
  }
};